import { action, observable, runInAction, when, makeObservable } from 'mobx';
import { runtime, Runtime } from '../../../../classes/runtime/Runtime';
import { sleep } from '../../../../utils/helper/helper_time';
import { xa } from '../../../../utils/xa/xa';

export class BrowserBot {
  readonly parent: Runtime;

  @observable manualBotStageWidthHeight; // 340

  constructor(parent) {
    makeObservable(this);
    this.parent = parent;
  }

  get runtime(): Runtime {
    return this.parent;
  }

  get botStageWidthHeight() {
    if (this.manualBotStageWidthHeight) return this.manualBotStageWidthHeight;
    return 1000;
  }

  @action.bound
  async saveFontSizeAndExpected() {
    const enableEdit = await when(() => !!this.runtime.streamedPackages.Edit);
    const enableSync = this.runtime.solidBrowserRuntime.app.edit;
  }

  @action.bound
  async fetchStageInner() {
    // disable save
    runtime.runtimeSync.isJustSimulating = true;
    console.log('set manualBotStageWidthHeight to 340');
    this.manualBotStageWidthHeight = 340;
    await sleep(4000);
    let stageInnerHtml = '';
    let stageOuterStyle = '';
    let stageInnerStyle = '';
    // let stageOuterHtml = '';

    try {
      stageInnerHtml = document.getElementsByClassName('stage_inner')[0].innerHTML;
      // stageOuterHtml = document.getElementsByClassName('stage_outer')[0].outerHTML;
      stageOuterStyle = document.getElementsByClassName('stage_outer')[0].getAttribute('style') || '';
      stageInnerStyle = document.getElementsByClassName('stage_inner')[0].getAttribute('style') || '';
    } catch (e) {}

    await xa.edit.setQuestionLoadHtml({
      stageInnerHtml,
      stageOuterStyle,
      stageInnerStyle,
      question_id: this.runtime.solidBrowserRuntime.app.question.id,
    });

    await xa.edit.setScreenshotDone({ questionId: this.runtime.solidBrowserRuntime.app.question.id });

    console.log('fetchStageInner', stageInnerHtml, stageOuterStyle, stageInnerStyle);

    console.log('Bot task COMPLETED!');
  }
}
